import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../clients';
import { betResponseSchema } from '../types';

export const receiveBet = createReceive('bet', zodContract(betResponseSchema));
